import { action, makeObservable, observable, runInAction } from 'mobx';
import { profileService } from '../../services';
import { ApiError, BuyerProfile, UpdateBuyerProfileRequest } from '../../types';

export class ProfileStore {
  profile: BuyerProfile | null = null;
  loading = false;
  error: ApiError | null = null;

  constructor() {
    makeObservable(this, {
      profile: observable,
      loading: observable,
      error: observable,
      load: action,
      update: action,
    });
  }

  async load(force = false): Promise<void> {
    if (this.profile && !force) return;
    this.loading = true;
    this.error = null;
    try {
      const profile = await profileService.me();
      runInAction(() => {
        this.profile = profile;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err as ApiError;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async update(patch: UpdateBuyerProfileRequest): Promise<BuyerProfile> {
    const next = await profileService.update(patch);
    runInAction(() => {
      this.profile = next;
    });
    return next;
  }
}
